<template>
  <div id="app">
    <div class="full-height">
      <el-row class="full-height">
        <el-col :span="4" class="full-height">
          <side-menu :projectChosen="projectChosen" @projectReset="resetProject"></side-menu>
        </el-col>
        <el-col :span="20" class="full-height">
          <top-bar :reset="projectReset" @projectChange="projectUpdate"></top-bar>
          <transition name="fade">
            <router-view/>
          </transition>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TopBar from './components/TopBar';
import SideMenu from './components/SideMenu';

export default {
  name: 'App',
  data: () => ({
    projectIndex: 0,
    projectReset: false,
  }),
  computed: {
    projectChosen() {
      return this.projectIndex !== 0;
    },
  },
  methods: {
    projectUpdate(id) {
      this.projectIndex = id;
      this.$router.push({ path: '/project' });
    },
    resetProject() {
      this.projectReset = true;
      this.projectIndex = 0;
    },
  },
  components: {
    'top-bar': TopBar,
    'side-menu': SideMenu,
  },
};
</script>

<style lang="scss">
html {
  font-size: 62.5%;
  height: 100%;
}

body {
  margin: 0;
  height: 100%;
}

#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .full-height {
    height: 100%;
    background-color: #fcfdff;
    position: relative;
  }

  .top-margin {
    margin-top: 80px;
    height: calc(100% - 80px);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue